import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { EMAbbreviateCardStatus } from './typings';

@Component({
  selector: 'm-abbreviate-card',
  template: `
    <div class="m-abbreviate-card-container">
      <div class="m-abbreviate-card-header" *ngIf="mTitle">
        <ng-container *nzStringTemplateOutlet="mTitle">{{ mTitle }}</ng-container>
      </div>
      <div class="m-abbreviate-card-body">
        <div class="m-abbreviate-card-img-box">
          <img class="m-abbreviate-card-img" [attr.src]="mSrc" alt="thumbnail" />
        </div>
      </div>
      <div class="m-abbreviate-card-extra">
        <ng-container *ngIf="isTemplateRef; else elseTemplate">
          <ng-container *nzStringTemplateOutlet="mStatus">{{ mStatus }}</ng-container>
        </ng-container>
        <ng-template #elseTemplate>
          <m-abbreviate-card-icon [mType]="type"></m-abbreviate-card-icon>
        </ng-template>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class MAbbreviateCardComponent {
  @Input() mSrc = '';
  @Input() mTitle!: string | TemplateRef<void>;
  @Input() mStatus!: EMAbbreviateCardStatus | TemplateRef<void>;

  get isTemplateRef(): boolean {
    return this.mStatus instanceof TemplateRef;
  }

  get type(): EMAbbreviateCardStatus {
    return this.mStatus as EMAbbreviateCardStatus;
  }
}
